import { IEntityBase } from './entityBase';

export enum UserProfileStatusColor {
  CONFIRMED = 'green.500',
  PENDING = 'red.500',
}

export enum UserProfileStatus {
  CONFIRMED = 'Confirmado',
  PENDING = 'Pendente',
}

export enum UserExperience {
  'Nível 1 e 2',
  'Nível 3 e 4',
  'Nível 4 e 5',
  'Nível 5 e 6',
  'Nível 6 e 7',
  'Nível 7',
  'Especial',
}

export enum UserGender {
  FEMALE = 'Feminino',
  MALE = 'Masculino',
  OTHER = 'Outros',
}

export interface IUserBase extends IEntityBase {
  avatar?: string;
  avatarUrl?: string;
  age?: number;
  bio?: string;
  birthDate?: string;
  categoryId?: string;
  confirmPending: boolean;
  cpf?: string;
  email: string;
  experience: UserExperience;
  featureGroupId?: string;
  gender?: UserGender;
  healthCheck?: string;
  hostId?: string;
  name: string;
  onboardingPending: boolean;
  phone?: string;
  ventureId?: string;
}
